import type { Movie, NewsItem } from "@/types/media";
import { movies } from "@/mocks/movies";
import { news } from "@/mocks/news";

export const typeLabels: Record<string, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const movieGenres = [
  "剧情",
  "动作",
  "喜剧",
  "科幻",
  "犯罪",
  "悬疑",
  "爱情",
  "奇幻",
  "古装",
  "都市",
  "青春",
  "家庭",
  "战争",
  "真人秀",
  "音乐",
  "旅行",
];

export const regions = [
  "中国大陆",
  "中国香港",
  "中国台湾",
  "美国",
  "韩国",
  "日本",
  "英国",
];

export const newsCategories = ["影视新闻", "影评", "专题活动"];

export const allMovies = movies as Movie[];
export const allNews = news as NewsItem[];

export function getMovieById(id: number): Movie | undefined {
  return allMovies.find((item) => item.id === id);
}

export function getNewsById(id: number): NewsItem | undefined {
  return allNews.find((item) => item.id === id);
}

export function getMoviesByType(type: string): Movie[] {
  return allMovies.filter((item) => item.type === type);
}

export function getRelatedMovies(movie: Movie, limit = 6): Movie[] {
  const scored = allMovies
    .filter((item) => item.id !== movie.id)
    .map((item) => {
      let score = 0;
      if (item.type === movie.type) score += 2;
      if (item.region === movie.region) score += 1;
      const shared = item.genres.filter((g) => movie.genres.includes(g)).length;
      score += shared * 3;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function searchMovies(keyword: string): Movie[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return allMovies.filter(
    (item) =>
      item.title.toLowerCase().includes(q) ||
      item.genres.some((g) => g.toLowerCase().includes(q)) ||
      item.actors.some((a) => a.toLowerCase().includes(q)) ||
      item.director.toLowerCase().includes(q)
  );
}

export function searchNews(keyword: string): NewsItem[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return allNews.filter(
    (item) =>
      item.title.toLowerCase().includes(q) ||
      item.summary.toLowerCase().includes(q)
  );
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}

export function formatDate(date: string): string {
  return date.replace(/-/g, ".");
}